import { queryClient } from '../../api';
import { cache } from '../../lib/stores/CacheStore.helpers';

export const clearDexieAndQueryClient = async () => {
	try {
		await cache.destroy();
		// This may cause null references to `user` in `useAuthUser` and crash the app
		queryClient.clear();
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('Error clearing cache', e);
	}
};

export const clearTokens = () => {
	// The impersonator token is used to impersonate other users, remove if it exists.
	localStorage.clear();
};

export const isImpersonating = () =>
	document.cookie.includes('is_impersonating');

/*
 * General utils for managing cookies in Typescript
 */
export function setCookie(name: string, val: string) {
	const date = new Date();
	const value = val;

	// Set it expire in 7 days
	date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);

	// Set it
	document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

export function getCookie(name: string) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);

	if (parts.length === 2) {
		return parts.pop()?.split(';').shift();
	}
	return null;
}

export function deleteCookie(name: string) {
	const date = new Date();

	// Set it expire in -1 days
	date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

	// Set it
	document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
}
